import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mob:false,
    virtualLink:null,
  },
  mutations: {
    setMob(state,data){
      state.mob = data;
    },
    setVirtualLink(state,data){
      state.virtualLink = null;
      state.virtualLink = data;
    }
  },
  actions: {
    getMob(store){
      let isMob = /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent);
      if (isMob) {        
        store.commit("setMob",isMob);
      }
    },
    getVirtualLink({ commit },payload){
      commit("setVirtualLink",payload);
    },
  },
  modules: {
  }
})
